import { clone } from '@jack-henry/frontend-utils/functions';
import { FilterBaseModelDto } from '@treasury/api/channel';
import { DomainEntity } from '../shared';

export const nullFilterBaseModelDto: FilterBaseModelDto = {
    name: '',
    description: '',
    reportType: '',
    standardReportTypeId: undefined,
    isStandardReport: true,
    dateType: '',
    fromDate: undefined,
    toDate: undefined,
    specificDate: undefined,
    priorDays: undefined,
    sortBy: '',
    isAscendingSort: false,
    owner: undefined,
    accountTypes: '',
    accounts: undefined,
    type: 'ir',
    sequence: undefined,
    isFavorite: false,
    id: 0,
    updatedDate: '',
};

export class ReportListItem extends DomainEntity<FilterBaseModelDto> {
    constructor(dto = clone(nullFilterBaseModelDto)) {
        super(dto);
        this.dto = dto;
    }

    public createDefault(): this {
        return new ReportListItem(this.dto) as this;
    }

    public get name() {
        return this.dto.name || '';
    }

    public get description() {
        return this.dto.description || '';
    }

    public get reportType() {
        return this.dto.reportType || '';
    }

    public get standardReportTypeId() {
        return this.dto.standardReportTypeId || 0;
    }

    public get isStandardReport() {
        return this.dto.isStandardReport || false;
    }

    public get dateType() {
        return this.dto.dateType || '';
    }

    public get fromDate() {
        return this.dto.fromDate || undefined;
    }

    public get toDate() {
        return this.dto.toDate || undefined;
    }

    public get specificDate() {
        return this.dto.specificDate || undefined;
    }

    public get priorDays() {
        return this.dto.priorDays || undefined;
    }

    public get isAscendingSort() {
        return this.dto.isAscendingSort || false;
    }

    public get accountTypes() {
        return this.dto.accountTypes || '';
    }

    public get accounts() {
        return this.dto.accounts || undefined;
    }

    public get type() {
        return this.dto.type || '';
    }

    public get sequence() {
        return this.dto.sequence || 0;
    }

    public get isFavorite() {
        return this.dto.isFavorite || false;
    }

    public set isFavorite(value: boolean) {
        this.dto.isFavorite = value;
    }

    public get id() {
        return this.dto.id || 0;
    }
}
